﻿/*-------------------------------------------------------
'   @module: HK - Article Variations
'---------------------------------------------------------*/
import { opaccAjaxPlugin } from "./vendor/script/opacc.static.js";

export class HKArticleVariations {
    constructor() {
        // selectors
        this.wrapperSelector = '.content';
        this.variationsSelector = `[data-art-action="show-variants"]`;
        this.modalCloseSelector = '.modal-close';
        this.variationsListSelector = '.variations-list';
        this.variationsSelectedSelector = '.variations-selected';
        this.selectVariationSelector = `[data-art-action="select-variation"]`;
        this.articleSelector = '.article-list-item';
        this.swapProdartSelector = `[data-art-action="swap-prodart"]`

        // properties
        this.wrapper = document.querySelector(this.wrapperSelector);
        this.variationsSelected = undefined;
        this.modal = undefined;
        this.prodArtToSwap = undefined;

        if(this.wrapper) {
            this.attachEventListener();
        }
    }

    /**
     * Attach event listener.
     */
    attachEventListener() {
        this.wrapper.addEventListener('click', e => {
            if(e.target.closest(this.variationsSelector)) {
                const button = e.target.closest(this.variationsSelector);
                this.prodArtToSwap = e.target.closest(this.articleSelector);
                opaccAjaxPlugin.fetchAsynGetForm(button.dataset.url, this.showVariations.bind(this), opaccAjaxPlugin.getDefaultErrorFnc.bind(this), true);
            }
        });
    }

    /**
     * Show variations modal.
     * @param {Object} response response object
     */
    showVariations(response) {
        if(response && response.success) {
            document.body.insertAdjacentHTML('beforeend',response.dataAsHtml);
            this.modal = document.querySelector('.modal-dimmer');

            if(this.modal) {
                this.variationsSelected = this.modal.querySelector(this.variationsSelectedSelector);
                this.modalAttachEventListener();
            }
        }
    }

    /**
     * Attach modal variations event listeners.
     */
    modalAttachEventListener() {
        this.modal.addEventListener('click', e => {
            // close modal
            if(e.target.closest(this.modalCloseSelector)) {
                this.modalDestroy();
            }

            // select variation
            if(e.target.closest(this.selectVariationSelector)) {
                const button = e.target.closest(this.selectVariationSelector);
                const wrapper = e.target.closest(this.variationsListSelector);

                // switch variation selection
                this.toggleSelectedVariation(wrapper, button);

                // switch selection button
                opaccAjaxPlugin.fetchAsynGetForm(button.dataset.url, this.switchVariationSelection.bind(this), opaccAjaxPlugin.getDefaultErrorFnc.bind(this), true);
            }

            // swap prodart
            if(e.target.closest(this.swapProdartSelector)) {
                const button = e.target.closest(this.swapProdartSelector);

                if(this.prodArtToSwap) {
                    opaccAjaxPlugin.fetchAsynGetForm(button.dataset.url, this.swapProdArt.bind(this), opaccAjaxPlugin.getDefaultErrorFnc.bind(this), true);
                }

                // when in details page, redirect to new detail url
                if(e.target.closest('.detail')) {
                    if(button.dataset.itemUrl) {
                        window.location = button.dataset.itemUrl;
                    }
                }
            }
        });
    }

    /**
     * Swap prodart with selected variant.
     * @param {OBject} response response object
     */
    swapProdArt(response) {
        if(response && response.success) {
            this.prodArtToSwap.outerHTML = response.dataAsHtml;
            this.modalDestroy();
        }
    }

    /**
     * Switch variation selection.
     * @param {Object} response response object
     */
    switchVariationSelection(response) {
        if(response && response.success) {
            this.variationsSelected.innerHTML = response.dataAsHtml;
        }
    }

    /**
     * Toggle selected variation.
     * @param {Object} wrapper available variations selector
     * @param {OBject} button clicked variation
     */
    toggleSelectedVariation(wrapper, button) {
        const variations = wrapper.querySelectorAll(this.selectVariationSelector);
        Array.from(variations).forEach(variation => {
            if (variation == button) {
                button.classList.remove('not-selected');
                button.classList.add('selected');
            } else {
                variation.classList.remove('selected');
                variation.classList.add('not-selected');
            }
        });
    }

    /**
     * Destroy modal.
     */
    modalDestroy() {
        this.modal.remove();
    }


}


new HKArticleVariations();

